<template>
  <div class="auth-page-container">
    <div class="ambient-glow ambient-glow--indigo"></div>
    <div class="ambient-glow ambient-glow--emerald"></div>

    <v-row align="center" justify="center" class="fill-height ma-0 auth-content-row">
      <v-col cols="12" sm="10" md="8" lg="5" xl="4">
        <v-card class="glass-card pa-6 pa-sm-8 auth-card" elevation="0">
          <div class="text-center mb-8">
            <div class="auth-brand-badge mb-3">
              <v-icon size="32" color="primary">mdi-shield-check-outline</v-icon>
            </div>
            <h1 class="text-h4 font-weight-bold mb-2">Activate Account</h1>
            <p class="text-body-2 text-medium-emphasis">
              Verify your email address to unlock your Media Catalog library
            </p>
          </div>

          <account-form
            :token="token"
            :email="email"
            @account-success="onActivateSuccess"
          />

          <v-divider class="my-6" />

          <div class="text-center">
            <v-btn
              to="/login"
              variant="text"
              class="btn-modern"
              prepend-icon="mdi-login"
            >
              Back to Sign In
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import AccountForm from '@/components/AccountForm.vue'

export default {
  name: 'AccountVerify',
  components: {
    AccountForm,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const token = route.query.token || ''
    const email = route.query.email || ''

    const onActivateSuccess = () => {
      router.push('/login')
    }

    return {
      onActivateSuccess,
      token,
      email,
    }
  },
}
</script>

<style scoped>
.auth-page-container {
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 32px 16px;
}

.auth-content-row {
  position: relative;
  z-index: 2;
  width: 100%;
}

.auth-card {
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25) !important;
}

.auth-brand-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.2);
}

.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  opacity: 0.25;
}

.ambient-glow--indigo {
  width: 450px;
  height: 450px;
  top: 10%;
  left: 20%;
  background: #6366f1;
}

.ambient-glow--emerald {
  width: 400px;
  height: 400px;
  bottom: 10%;
  right: 20%;
  background: #10b981;
}
</style>